export default __webpack_public_path__ + "static/avatarLaki-3f5874cc4d29e39e125287884e3f9b06.jpeg";